

























import { Component, Vue, Prop, Model } from 'nuxt-property-decorator';

import { IconCheckCircle } from '@/icons';

@Component({
  inheritAttrs: false,
  components: {
    IconCheckCircle,
  },
})
export default class Checkbox extends Vue {
  @Model('change', { type: Boolean, default: false })
  checked!: Boolean;

  @Prop(Boolean)
  disabled!: Boolean;

  @Prop({ type: String, default: 'checkbox' })
  type!: string;

  @Prop(String)
  title!: string;

  @Prop(String)
  suffix!: string;

  get id () {
    return `checkbox_${this._uid}`;
  }

  get listeners () {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { change, ...rest } = this.$listeners;
    return rest;
  }

  clickCheckbox () {
    (this.$refs.checkbox as HTMLInputElement).click();
  }
}
